module.exports = __webpack_public_path__ + "fonts/Poppins-Italic.5e956c44.ttf";